import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthModal from '../ui/AuthModal';
import DailyDiscoveryService from '../../services/dailyDiscovery';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../i18n/translations';

const Feature = ({ id, image, title, description, onClick, disabled = false }) => {
  const [showAuthModal, setShowAuthModal] = useState(false);
 
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };

  return (
    <>
      <div 
        className={`feature-section ${disabled ? 'disabled' : ''}`}
        onClick={handleClick}
      >
        <div className="feature-image">
          <img src={image} alt={title} />
        </div>
        <div className="feature-content">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
      </div>

      <AuthModal 
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onLogin={() => {}}
      />
    </>
  );
};

const Home = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const { t } = useTranslation(language);
  const [discoveryTitle, setDiscoveryTitle] = useState('');

  // Carica titolo discovery del giorno
  useEffect(() => {
    const loadDiscoveryTitle = async () => {
      try {
        const discovery = await DailyDiscoveryService.getTodayDiscovery(language);
        if (discovery && discovery.title) {
          setDiscoveryTitle(discovery.title);
        } else {
          setDiscoveryTitle(t('home.dailyDiscovery.title'));
        }
      } catch (error) {
        console.log('[Home] Could not load discovery title');
        setDiscoveryTitle(t('home.dailyDiscovery.title'));
      }
    };
    loadDiscoveryTitle();
  }, [language, t]);

  const features = [
    {
      id: 'similar',
      image: `${process.env.PUBLIC_URL}/img/cerca.jpg`,
      title: t('home.similarArtists.title'),
      description: t('home.similarArtists.description'),
      onClick: () => navigate('/similar', {
        state: {
          type: 'similar'
        }
      })
    },
    {
      id: 'daily-discovery',
      image: `${process.env.PUBLIC_URL}/img/daily.jpg`,
      title: discoveryTitle,
      description: t('home.dailyDiscovery.description'),
      onClick: () => {
        // Naviga con flag per caricare sempre l'ultimo approfondimento
        navigate('/daily-discovery', {
          state: {
            type: 'daily-discovery',
            loadLatest: true, // Flag per caricare sempre l'ultimo
            timestamp: Date.now() // Forza React a vedere il cambio
          }
        });
      }
    },
    {
      id: 'random',
      image: `${process.env.PUBLIC_URL}/img/random.jpg`,
      title: t('home.randomArtists.title'),
      description: t('home.randomArtists.description'),
      onClick: () => navigate('/random', {
        state: {
          type: 'random'
        }
      })
    }
  ];

  return (
    <div className="features-container">
      {features.map(feature => (
        <Feature
          key={feature.id}
          {...feature}
        />
      ))}
    </div>
  );
};

export default Home;